export const github = "https://github.com/smaranan2019";
export const linkedin = "https://www.linkedin.com/in/francesseverino/";
export const medium = "https://medium.com/@smaranan.2019";
export const name = "Frances Severino";